import "./Modals.scss";
import { useState } from "react";
import axios from "axios";

const TextInput = ({ inputTitle, inputPlaceholder, value, setValue, type, hint = false, error = false }) => {
  return (
    <div className="inputContainer">
      <p className="inputTitle">{inputTitle}</p>
      <input
        className={error ? "errorInput" : "regularInput"}
        type={type}
        placeholder={inputPlaceholder}
        value={value}
        onChange={(e) => setValue(e?.target?.value)}
      />
      <p className="hint">{hint}</p>
      <p className="errorText">{error}</p>
    </div>
  );
};

const PhoneInput = ({ inputTitle, inputPlaceholder, value, setValue, error, getCodeButton, setPrefix, hideButton }) => {
  // Custom handler for phone input change
  const handlePhoneInputChange = (e) => {
    const inputVal = e.target.value;
    // Allow only numbers and an optional leading '+' sign
    if (/^\+?[0-9]*$/.test(inputVal)) {
      setValue(inputVal);
    }
  };

  return (
    <div className="inputContainer">
      <p className="inputTitle">
        <span>{inputTitle}</span>{" "}
        <button
          onClick={() => {
            getCodeButton();
          }}
          className={hideButton === false ? "getCodeButton" : "hideButton getCodeButton"}
        >
          Get Code
        </button>
      </p>
      <div className="phoneInputsBlock">
        <select
          onChange={(e) => setPrefix(e.target.value)}
          className="prefixSelect"
          name="prefixSelect"
          id="prefixSelect"
        >
          <option key={"+91"} value={"+91"}>
            IND +91
          </option>
          <option key={"+880"} value={"+880"}>
            BGD +880
          </option>
          <option key={"+92"} value={"+92"}>
            PAK +92
          </option>
          <option key={"+977"} value={"+977"}>
            NPL +977
          </option>
          <option key={"+975"} value={"+975"}>
            BTN +975
          </option>
          <option key={"+94"} value={"+94"}>
            LKA +94
          </option>
          <option key={"+95"} value={"+95"}>
            MMR +95
          </option>
        </select>

        <input
          className={error ? "errorInput" : "regularInput"}
          type="text"
          placeholder={inputPlaceholder}
          value={value}
          onChange={handlePhoneInputChange}
        />
      </div>
      <p className="errorText">{error}</p>
    </div>
  );
};

const SelectInput = ({ value, setValue, error }) => {
  return (
    <div className="inputContainer">
      <p className="inputTitle">Select Size</p>
      <select value={value} onChange={(e) => setValue(e.target.value)} className="fit-select">
        {["XS", "S", "M", "L", "XL", "XXL"].map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>

      <p className="errorText">{error}</p>
    </div>
  );
};

const InputModals = ({ showInput, sendData, showModalPolicy }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [player, setPlayer] = useState("");
  const [fitSize, setFitSize] = useState("M");
  const [errorsObject, setErrorsObject] = useState({
    name: false,
    phone: false,
    email: false,
    player: false,
    checkbox: false,
    fitSize: false,
    otp: false,
  });
  const [checkboxDone, setCheckboxDone] = useState(false);
  const [generalError, setGeneralError] = useState("");
  const [prefix, setPrefix] = useState("+91");
  const [OTP, setOTP] = useState("");
  const [OTPCorrect, setOTPCorrect] = useState("none");
  const [confirmedPhoneNumber, setConfirmedPhoneNumber] = useState("");
  const [hideButtonGetCode, setHideButtonGetCode] = useState(false);

  const validateData = async () => {
    const newErrorsObject = {
      name: false,
      phone: false,
      confirmedPhoneNumber: false,
      email: false,
      player: false,
      checkbox: true,
      otp: false,
    };
    let foundError = false;

    if (name?.length < 1) {
      newErrorsObject.name = "Enter your name";
      foundError = true;
    } else {
      newErrorsObject.name = false;
    }

    if (parseInt(confirmedPhoneNumber) && confirmedPhoneNumber?.length > 8) {
      newErrorsObject.confirmedPhoneNumber = false;
    } else {
      newErrorsObject.phone = "Confirm your phone by getting code";
      foundError = true;
    }

    if (email?.length < 5 || !email.includes("@") || !email.includes(".")) {
      newErrorsObject.email = "Enter valid email";
      foundError = true;
    } else {
      newErrorsObject.email = false;
    }

    if (player?.length < 1) {
      newErrorsObject.player = "Enter player name";
      foundError = true;
    } else {
      newErrorsObject.player = false;
    }

    if (!checkboxDone) {
      newErrorsObject.checkbox = true;
      foundError = true;
    } else {
      newErrorsObject.checkbox = false;
    }

    if (OTPCorrect === false) {
      console.log(OTPCorrect, `OTP INCORRECT`);
      newErrorsObject.otp = "Incorrect OTP";
      foundError = true;
    } else {
      newErrorsObject.otp = false;
    }

    setErrorsObject(newErrorsObject);

    if (!foundError) {
      if (name && confirmedPhoneNumber && email && player && fitSize) {
        axios
          .post("https://batery.ai:3000/checkOTP", {
            phoneNumber: confirmedPhoneNumber,
            OTP,
          })
          .then((data) => {
            if (data?.data?.status === 200) {
              console.log(`Sending data`);
              sendData(name, confirmedPhoneNumber, email, player, fitSize);
              showInput(false);
            } else {
              setErrorsObject((prevObject) => ({
                ...prevObject,
                otp: `Incorrect OTP`,
              }));
            }
          });
      } else {
        setGeneralError(`An error occured, please try again`);
      }
    }
  };

  const getCode = async () => {
    const phoneNumber = `${prefix}${phone}`;

    setHideButtonGetCode(true);

    setTimeout(() => {
      setHideButtonGetCode(false);
    }, 30000);

    const response = await axios.post("https://batery.ai:3000/sendCode", {
      phoneNumber,
    });

    if (response?.data?.status !== 200) {
      setErrorsObject((prevState) => ({
        ...prevState,
        phone: response?.data?.message,
      }));
    } else {
      setConfirmedPhoneNumber(phoneNumber);
      setErrorsObject((prevState) => ({
        ...prevState,
        phone: false,
      }));
    }
  };

  return (
    <div className="modalsWrapper">
      <div className="backdrop" onClick={() => showInput(false)}></div>

      <div className="modalsContainer">
        <div className="header">
          <p className="modalTitle">Get your jersey!</p>
          <button className="closeButton" onClick={() => showInput(false)}>
            <img src="/close.png" alt="X" />
          </button>
        </div>

        <div className="inputsBlock">
          <TextInput
            inputTitle={"Name"}
            inputPlaceholder={"Insert name"}
            value={name}
            setValue={setName}
            type={"Name"}
            error={errorsObject.name}
          />

          <PhoneInput
            inputTitle={"Phone"}
            inputPlaceholder={"Insert phone"}
            value={phone}
            setValue={setPhone}
            setPrefix={setPrefix}
            error={errorsObject.phone}
            getCodeButton={getCode}
            hideButton={hideButtonGetCode}
          />

          <TextInput
            inputTitle={"Confirmation Code"}
            inputPlaceholder={"Insert OTP"}
            value={OTP}
            setValue={setOTP}
            type={"OTP"}
            error={errorsObject.otp}
          />

          <TextInput
            inputTitle={"Email"}
            inputPlaceholder={"Insert email"}
            value={email}
            setValue={setEmail}
            type={"Email"}
            error={errorsObject.email}
          />

          <TextInput
            inputTitle={"Your Favorite Player"}
            inputPlaceholder={"Insert player"}
            value={player}
            setValue={setPlayer}
            type={"text"}
            error={errorsObject.player}
          />

          <SelectInput value={fitSize} setValue={setFitSize} error={errorsObject.fitSize} />
        </div>

        <div className="policyBlock">
          <input
            type="checkbox"
            className="checkbox"
            onChange={() => {
              setCheckboxDone(!checkboxDone);
            }}
          />

          <p className={errorsObject.checkbox ? "errorCheckboxText" : "policyText"}>
            I have read, understand and agree with the
            <span className="policyHighlightedText" onClick={() => showModalPolicy(true)}>
              Terms and Conditions, Privacy Policy
            </span>
            , and confirm that I am over 18 years of age.
          </p>
        </div>

        <div className="buttonBlock">
          <button onClick={() => validateData()}>Continue</button>

          <p className="generalError">{generalError}</p>
        </div>
      </div>
    </div>
  );
};

export default InputModals;
